import Vue from 'vue'
import moment from 'moment'
import { Button, Table, Modal, Select, Radio, Input, Tabs, Form, DatePicker, message } from 'ant-design-vue'
import passengerSegList from '@/components/passenger-seg-list'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Table)
Vue.use(Select)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(passengerSegList)

Vue.prototype.$message = message
Vue.prototype.$modal = Modal
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.moment = moment
